/* eslint no-template-curly-in-string: 0 */
import { FLOW_TYPES, PAYMENT_NETWORKS, PAYMENT_STATUSES } from "../../utils/enums";
import mastercardLogo from "../../assets/images/mastercard-logo.png";
import prepaidMastercardFees from "../../assets/images/Disburse-Virtual_MC_Disclosure_Short Form_Equifax.pdf";

const aboutNetworkFaq = {
  answer: "Virtual Account is issued by MetaBank®, Member FDIC, pursuant to license by Mastercard International Incorporated. Mastercard is a registered trademark, and the circles design is a trademark of Mastercard International Incorporated. No cash access or recurring payments. Can be used online, phone/mail or in stores that accept mobile wallet where Debit Mastercard is accepted in the US. Account valid for up to 7 years; funds do not expire and may be available after card expiration date, fees may apply.",
  question: "About Mastercard® Gift Card"
};

const disclosureOfFeesFaq = {
  answer: `<a href="${prepaidMastercardFees}" target="_blank">Disclosure of Fees</a>`,
  question: "Mastercard® Gift Card Disclosure of Fees"
};

export const mastercard ={
  id: PAYMENT_NETWORKS.MASTERCARD,
  displayName: "Virtual Mastercard",
  paymentFlow: "email",
  paywall: {
    tile: {
      displayName: ["Mastercard® Gift Card"],
      tagline: [
        {
          type: 'div',
          string: "Virtual card for online or in-store purchases",
          props: {
            style: {
              fontSize: '0.9em'
            }
          }
        }
      ],
      description: [
        {
          string: 'Use wherever Mastercard is accepted.',
          type: 'div'
        },
        {
          string: "Not for cash withdrawals or transfers.",
          type: 'div'
        }
      ],
      // btnLabel: "Next",
      logo: mastercardLogo
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparing your Mastercard™"
    }
  },
  acceptPayment: {
    flow: FLOW_TYPES.ACCEPT_PAYMENT.BASIC,
    btnLabel: "GET MY MASTERCARD",
    description: [
      "You have chosen to receive a ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " Virtual Mastercard which will be emailed to ",
      {
        string: "${payment.recipientEmail}.",
        props: {
          className: 'payment-recipientEmail'
        }
      },
    ],
    disclaimer: [
      {
        string: 'This card is for online or point of sale purchases. Cash balance cannot be transferred. We encourage you to use your card once every 12 months to avoid inactivity fees. After one year of inactivity, monthly fees of $5.95 occur.',
        props: {
          style: {
            fontSize: "0.8rem",
            lineHeight: "1.2",
            padding: "0 1em",
            display: "block",
            textAlign: "center",
            marginBottom: "2em",
          }
        }
      }
    ],
    imgSrc: mastercardLogo
  },
  networkSelectionAccepted: {
    imgSrc: mastercardLogo,
  },
  paymentComplete: {
    initial: {
      description: [
        "Success! Please check your email ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail',
          },
        },
        " for details regarding your ",
        {
          string: "Virtual Mastercard",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ". It should arrive within 24 to 48 hours and will include details for your use.",
      ],
      secondaryText: "Upon receipt, please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    revisit: {
      description: [
        "An email was sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " on ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt'
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        " with details regarding your ",
        {
          string: "Virtual Mastercard",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ".",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    imgSrc: mastercardLogo,
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        aboutNetworkFaq,
        disclosureOfFeesFaq,
      ],
      [PAYMENT_STATUSES.ACCEPTED]: [
        aboutNetworkFaq,
        disclosureOfFeesFaq,
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        aboutNetworkFaq,
        disclosureOfFeesFaq,
      ]
    }
  },
  onHold: {
    imgSrc: mastercardLogo,
    description: 'Your payment selection has been received. In most cases, funds are instantly sent; however in some instances it can take 24 to 48 hours for money to arrive.',
  }
};

export default mastercard;
